import React, { Fragment } from 'react';
import { routeCharacteristicsInformationPropTypes } from '../proptypes/RoutePropTypes';
import Checkbox from '../../../../common/forms/Checkbox';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import EnumStatus from '../../../../common/EnumStatus';
import { ROUTE_LENGTH_TYPE_OPTIONS } from '../../../../../config/constants';

const RouteCharacteristicsInformationResource = ({
  hotZone,
  coldZone,
  steepRoute,
  flatRoute,
  lengthType,
}) => (
  <Fragment>
    <h3>Características</h3>
    <div>
      <Checkbox checked={hotZone} /> Zona Cálida
    </div>
    <div>
      <Checkbox checked={coldZone} /> Zona Fría
    </div>
    <div>
      <Checkbox checked={steepRoute} /> Ruta Empinada
    </div>
    <div>
      <Checkbox checked={flatRoute} /> Ruta Llana
    </div>
    <ResourceProperty label="Tipo de Longitud:">
      <EnumStatus
        enumObject={ROUTE_LENGTH_TYPE_OPTIONS}
        enumValue={lengthType}
      />
    </ResourceProperty>
  </Fragment>
);

RouteCharacteristicsInformationResource.propTypes =
  routeCharacteristicsInformationPropTypes;

export default RouteCharacteristicsInformationResource;
